var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303",
    transform: "translate(-321 -1888)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8691",
    "data-name": "Rectangle 8691",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(321 1888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_lock",
    "data-name": "vuesax/outline/lock",
    transform: "translate(221.47 1580.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(108 316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.751,15.461a1.23,1.23,0,0,1-1.221-1.221V10.986c0-5.127-1.448-8.544-8.544-8.544S2.441,5.859,2.441,10.986v3.255a1.23,1.23,0,0,1-1.221,1.221A1.23,1.23,0,0,1,0,14.241V10.986C0,6.266,1.139,0,10.986,0S21.971,6.266,21.971,10.986v3.255A1.23,1.23,0,0,1,20.751,15.461Z",
    transform: "translate(8.544 2.034)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M25.633,21.971H9.358C2.181,21.971,0,19.79,0,12.613V9.358C0,2.181,2.181,0,9.358,0H25.633c7.177,0,9.358,2.181,9.358,9.358v3.255C34.991,19.79,32.81,21.971,25.633,21.971ZM9.358,2.441c-5.826,0-6.917,1.107-6.917,6.917v3.255c0,5.81,1.09,6.917,6.917,6.917H25.633c5.826,0,6.917-1.107,6.917-6.917V9.358c0-5.81-1.09-6.917-6.917-6.917Z",
    transform: "translate(2.034 15.054)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.628,3.253a1.62,1.62,0,0,1-.618-.13,1.68,1.68,0,0,1-.537-.342A1.681,1.681,0,0,1,0,1.626a1.62,1.62,0,0,1,.13-.618A1.68,1.68,0,0,1,.472.47,1.68,1.68,0,0,1,1.009.128,1.631,1.631,0,0,1,2.783.47a1.879,1.879,0,0,1,.342.537,1.62,1.62,0,0,1,.13.618,1.711,1.711,0,0,1-.472,1.156A1.711,1.711,0,0,1,1.628,3.253Z",
    transform: "translate(11.392 24.414)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1.628,3.256A1.711,1.711,0,0,1,.472,2.784,1.681,1.681,0,0,1,0,1.629,1.365,1.365,0,0,1,.13,1.01,1.879,1.879,0,0,1,.472.473,1.625,1.625,0,0,1,1.937.034a.982.982,0,0,1,.309.1,1.232,1.232,0,0,1,.293.147,2.564,2.564,0,0,1,.244.2,1.879,1.879,0,0,1,.342.537,1.62,1.62,0,0,1,.13.618,1.681,1.681,0,0,1-.472,1.156l-.244.2a1.232,1.232,0,0,1-.293.147.982.982,0,0,1-.309.1A1.994,1.994,0,0,1,1.628,3.256Z",
    transform: "translate(17.903 24.411)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.628,3.256A1.681,1.681,0,0,1,.472,2.784,1.879,1.879,0,0,1,.13,2.247,1.62,1.62,0,0,1,0,1.629,1.711,1.711,0,0,1,.472.473l.244-.2A1.232,1.232,0,0,1,1.009.132,1.034,1.034,0,0,1,1.3.034,1.656,1.656,0,0,1,2.783.473a1.681,1.681,0,0,1,.472,1.156,1.62,1.62,0,0,1-.13.618,1.68,1.68,0,0,1-.342.537A1.711,1.711,0,0,1,1.628,3.256Z",
    transform: "translate(24.413 24.411)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H39.06V39.06H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.fdb62ddf4a81c69e19330d63a36595cc.svg";
export { ForwardRef as ReactComponent };